"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  contains: function contains() {
    return _contains;
  },
  getActiveElement: function getActiveElement() {
    return _getActiveElement;
  },
  getAllFocusable: function getAllFocusable() {
    return _getAllFocusable;
  },
  getAllTabbable: function getAllTabbable() {
    return _getAllTabbable;
  },
  getEventWindow: function getEventWindow() {
    return _getEventWindow;
  },
  getFirstFocusable: function getFirstFocusable() {
    return _getFirstFocusable;
  },
  getFirstTabbableIn: function getFirstTabbableIn() {
    return _getFirstTabbableIn;
  },
  getLastTabbableIn: function getLastTabbableIn() {
    return _getLastTabbableIn;
  },
  getNextTabbable: function getNextTabbable() {
    return _getNextTabbable;
  },
  getOwnerDocument: function getOwnerDocument() {
    return _getOwnerDocument;
  },
  getOwnerWindow: function getOwnerWindow() {
    return _getOwnerWindow;
  },
  getPreviousTabbable: function getPreviousTabbable() {
    return _getPreviousTabbable;
  },
  getScrollParent: function getScrollParent() {
    return _getScrollParent;
  },
  hasDisplayNone: function hasDisplayNone() {
    return _hasDisplayNone;
  },
  hasFocusWithin: function hasFocusWithin() {
    return _hasFocusWithin;
  },
  hasNegativeTabIndex: function hasNegativeTabIndex() {
    return _hasNegativeTabIndex;
  },
  hasTabIndex: function hasTabIndex() {
    return _hasTabIndex;
  },
  isActiveElement: function isActiveElement() {
    return _isActiveElement;
  },
  isBrowser: function isBrowser() {
    return _isBrowser;
  },
  isContentEditable: function isContentEditable() {
    return _isContentEditable;
  },
  isDisabled: function isDisabled() {
    return _isDisabled;
  },
  isElement: function isElement() {
    return _isElement;
  },
  isFocusable: function isFocusable() {
    return _isFocusable;
  },
  isHTMLElement: function isHTMLElement() {
    return _isHTMLElement;
  },
  isHidden: function isHidden() {
    return _isHidden;
  },
  isInputElement: function isInputElement() {
    return _isInputElement;
  },
  isTabbable: function isTabbable() {
    return _isTabbable;
  }
});
module.exports = __toCommonJS(src_exports);

// src/dom.ts
function _isElement(el) {
  return el != null && _typeof(el) == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function _isHTMLElement(el) {
  var _a;
  if (!_isElement(el)) return false;
  var win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
  return el instanceof win.HTMLElement;
}
function _getOwnerWindow(node) {
  var _a, _b;
  return (_b = (_a = _getOwnerDocument(node)) == null ? void 0 : _a.defaultView) != null ? _b : window;
}
function _getOwnerDocument(node) {
  return _isElement(node) ? node.ownerDocument : document;
}
function _getEventWindow(event) {
  var _a;
  return (_a = event.view) != null ? _a : window;
}
function _isBrowser() {
  return Boolean(globalThis == null ? void 0 : globalThis.document);
}
function _getActiveElement(node) {
  return _getOwnerDocument(node).activeElement;
}
function _contains(parent, child) {
  if (!parent) return false;
  return parent === child || parent.contains(child);
}

// src/tabbable.ts
var _hasDisplayNone = function _hasDisplayNone(element) {
  return window.getComputedStyle(element).display === "none";
};
var _hasTabIndex = function _hasTabIndex(element) {
  return element.hasAttribute("tabindex");
};
var _hasNegativeTabIndex = function _hasNegativeTabIndex(element) {
  return _hasTabIndex(element) && element.tabIndex === -1;
};
function _isDisabled(element) {
  return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function _isInputElement(element) {
  return _isHTMLElement(element) && element.localName === "input" && "select" in element;
}
function _isActiveElement(element) {
  var doc = _isHTMLElement(element) ? _getOwnerDocument(element) : document;
  return doc.activeElement === element;
}
function _hasFocusWithin(element) {
  if (!document.activeElement) return false;
  return element.contains(document.activeElement);
}
function _isHidden(element) {
  if (element.parentElement && _isHidden(element.parentElement)) return true;
  return element.hidden;
}
function _isContentEditable(element) {
  var value = element.getAttribute("contenteditable");
  return value !== "false" && value != null;
}
function _isFocusable(element) {
  if (!_isHTMLElement(element) || _isHidden(element) || _isDisabled(element)) {
    return false;
  }
  var localName = element.localName;
  var focusableTags = ["input", "select", "textarea", "button"];
  if (focusableTags.indexOf(localName) >= 0) return true;
  var others = {
    a: function a() {
      return element.hasAttribute("href");
    },
    audio: function audio() {
      return element.hasAttribute("controls");
    },
    video: function video() {
      return element.hasAttribute("controls");
    }
  };
  if (localName in others) {
    return others[localName]();
  }
  if (_isContentEditable(element)) return true;
  return _hasTabIndex(element);
}
function _isTabbable(element) {
  if (!element) return false;
  return _isHTMLElement(element) && _isFocusable(element) && !_hasNegativeTabIndex(element);
}

// src/scroll.ts
function isScrollParent(el) {
  var win = el.ownerDocument.defaultView || window;
  var _win$getComputedStyle = win.getComputedStyle(el),
    overflow = _win$getComputedStyle.overflow,
    overflowX = _win$getComputedStyle.overflowX,
    overflowY = _win$getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getParent(el) {
  if (el.localName === "html") return el;
  return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function _getScrollParent(el) {
  if (["html", "body", "#document"].includes(el.localName)) {
    return el.ownerDocument.body;
  }
  if (_isHTMLElement(el) && isScrollParent(el)) {
    return el;
  }
  return _getScrollParent(getParent(el));
}

// src/index.ts
var focusableElList = ["input:not(:disabled):not([disabled])", "select:not(:disabled):not([disabled])", "textarea:not(:disabled):not([disabled])", "embed", "iframe", "object", "a[href]", "area[href]", "button:not(:disabled):not([disabled])", "[tabindex]", "audio[controls]", "video[controls]", "*[tabindex]:not([aria-disabled])", "*[contenteditable]"];
var focusableElSelector = focusableElList.join();
var isVisible = function isVisible(el) {
  return el.offsetWidth > 0 && el.offsetHeight > 0;
};
function _getAllFocusable(container) {
  var focusableEls = Array.from(container.querySelectorAll(focusableElSelector));
  focusableEls.unshift(container);
  return focusableEls.filter(function (el) {
    return _isFocusable(el) && isVisible(el);
  });
}
function _getFirstFocusable(container) {
  var allFocusable = _getAllFocusable(container);
  return allFocusable.length ? allFocusable[0] : null;
}
function _getAllTabbable(container, fallbackToFocusable) {
  var allFocusable = Array.from(container.querySelectorAll(focusableElSelector));
  var allTabbable = allFocusable.filter(_isTabbable);
  if (_isTabbable(container)) {
    allTabbable.unshift(container);
  }
  if (!allTabbable.length && fallbackToFocusable) {
    return allFocusable;
  }
  return allTabbable;
}
function _getFirstTabbableIn(container, fallbackToFocusable) {
  var _getAllTabbable2 = _getAllTabbable(container, fallbackToFocusable),
    _getAllTabbable3 = _slicedToArray(_getAllTabbable2, 1),
    first = _getAllTabbable3[0];
  return first || null;
}
function _getLastTabbableIn(container, fallbackToFocusable) {
  var allTabbable = _getAllTabbable(container, fallbackToFocusable);
  return allTabbable[allTabbable.length - 1] || null;
}
function _getNextTabbable(container, fallbackToFocusable) {
  var allFocusable = _getAllFocusable(container);
  var index = allFocusable.indexOf(document.activeElement);
  var slice = allFocusable.slice(index + 1);
  return slice.find(_isTabbable) || allFocusable.find(_isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
function _getPreviousTabbable(container, fallbackToFocusable) {
  var allFocusable = _getAllFocusable(container).reverse();
  var index = allFocusable.indexOf(document.activeElement);
  var slice = allFocusable.slice(index + 1);
  return slice.find(_isTabbable) || allFocusable.find(_isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  contains: _contains,
  getActiveElement: _getActiveElement,
  getAllFocusable: _getAllFocusable,
  getAllTabbable: _getAllTabbable,
  getEventWindow: _getEventWindow,
  getFirstFocusable: _getFirstFocusable,
  getFirstTabbableIn: _getFirstTabbableIn,
  getLastTabbableIn: _getLastTabbableIn,
  getNextTabbable: _getNextTabbable,
  getOwnerDocument: _getOwnerDocument,
  getOwnerWindow: _getOwnerWindow,
  getPreviousTabbable: _getPreviousTabbable,
  getScrollParent: _getScrollParent,
  hasDisplayNone: _hasDisplayNone,
  hasFocusWithin: _hasFocusWithin,
  hasNegativeTabIndex: _hasNegativeTabIndex,
  hasTabIndex: _hasTabIndex,
  isActiveElement: _isActiveElement,
  isBrowser: _isBrowser,
  isContentEditable: _isContentEditable,
  isDisabled: _isDisabled,
  isElement: _isElement,
  isFocusable: _isFocusable,
  isHTMLElement: _isHTMLElement,
  isHidden: _isHidden,
  isInputElement: _isInputElement,
  isTabbable: _isTabbable
});